import React, { useState } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useActiveApplications } from "services/applicationService";
import SubmitButton from "components/common/SubmitButton";

const AddEdit = (props) => {
  const ADD_NEW = props.type === "add";
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: appData } = useActiveApplications();

  const validateForm = (values) => {
    const errors = {};
    if (!values.rateCategoryName) {
      errors.rateCategoryName = "Rate Category is required.";
    }
    if (
      !values.allowAllApps &&
      (!values.applications || values.applications.length === 0)
    ) {
      errors.applications = "Application is required.";
    }
    return errors;
  };

  const handleFormSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      const newData = {
        ...formData,
        active: ADD_NEW ? true : formData.active,
        type: 0,
      };

      if (!ADD_NEW) {
        newData.rateCategoryId = props.item.rateCategoryId;
      }

      await props.onSubmit(newData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <Form
          id="rates-form"
          ignoreModified
          onSubmit={handleFormSubmit}
          initialValues={ADD_NEW ? {} : props.item}
          validator={validateForm}
          render={(formRenderProps) => (
            <>
              <FormElement style={{ maxWidth: 1000 }}>
                <fieldset className="k-form-fieldset p-3 ps-4">
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Rate Category Name
                    </Label>
                    <Field
                      name="rateCategoryName"
                      placeholder="Enter Rate Category Name"
                      component={Input}
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.rateCategoryName && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.rateCategoryName}</i>
                        </div>
                      )}
                  </div>

                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">
                      Applications
                    </Label>
                    <Field
                      name="applications"
                      component={(props) => (
                        <MultiSelect {...props} className="py-2 px-1" />
                      )}
                      data={appData || []}
                      textField="appCode"
                      placeholder="Select App"
                      disabled={formRenderProps.valueGetter("allowAllApps")}
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.applications && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.applications}</i>
                        </div>
                      )}
                  </div>

                  <div className="mb-3">
                    <Field
                      name="allowAllApps"
                      component={Checkbox}
                      label="For all applications"
                      style={{ marginRight: "10px", width: "20px" }}
                    />
                  </div>

                  {!ADD_NEW && (
                    <div className="mb-3">
                      <Field
                        name="active"
                        component={Checkbox}
                        label="Active"
                        style={{ marginRight: "10px", width: "20px" }}
                      />
                    </div>
                  )}
                </fieldset>
                <div className="dialog-footer">
                  <Button
                    className="bgBtnSecondary common-btn me-2"
                    onClick={props.cancelEdit}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    className="me-3"
                    onClick={(e) => {
                      e.preventDefault();
                      formRenderProps.onSubmit();
                      setSubmitAttempted(true);
                    }}
                    isLoading={isSubmitting}
                    disabled={!ADD_NEW && !formRenderProps.modified}
                  >
                    {ADD_NEW ? "Save" : "Update"}
                  </SubmitButton>
                </div>
              </FormElement>
            </>
          )}
        />
      </div>
    </>
  );
};

export default AddEdit;
